import { gql } from '@apollo/client';

// Fetch single device tag rule detail for editing.
// inclusionTags/exclusionTags are GraphQLJSONObject (blackbox JSON) containing
// recursive rule tree: { type: 'ruleset', condition, rules: [...] }
export const DEVICE_TAG_RULE_DETAIL_QUERY = gql`
  query DeviceTagRuleDetail($_id: String!, $teamId: String) {
    deviceTagRule(_id: $_id, teamId: $teamId) {
      _id
      name
      currentType
      inclusionTags
      exclusionTags
    }
  }
`;

// Upsert device tag rule. If payload._id is present, updates; otherwise creates.
// inclusionTags/exclusionTags sent as JSON (blackbox).
export const SAVE_DEVICE_TAG_RULES = gql`
  mutation SaveDeviceTagRules($teamId: String, $payload: DeviceTagRuleInput!) {
    saveDeviceTagRules(teamId: $teamId, payload: $payload) {
      _id
      name
      currentType
      inclusionTags
      exclusionTags
    }
  }
`;

export const DELETE_DEVICE_TAG_RULES = gql`
  mutation DeleteDeviceTagRules($teamId: String!, $_id: String!) {
    deleteDeviceTagRules(teamId: $teamId, _id: $_id)
  }
`;
